<template>

</template>

<script>
export default {
  name: 'line-jump',
  methods: {
    parseUrl() {
      const url = decodeURIComponent(window.location.href);
      const index = url.indexOf("?");
      const params = url.slice(index + 1).split("&");
      const query = {};
      params.forEach((item) => {
        const tempIndex = item.indexOf("=");
        if (tempIndex > 0) {
          const key = String(item.slice(0, tempIndex));
          query[key] = item.slice(tempIndex + 1);
        }
      });
      let campaign_url = `https://haqy.adj.st?adj_t=t90ih3x_27pmkhc&adj_campaign=${query.giftcode}`
      console.log(campaign_url)
      window.location.href = campaign_url
    }
  },
  mounted() {
    this.parseUrl()
  }
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/link-jump.vue